/**
 * Map an ISO timestamp to a 0-based day bucket within the last `windowDays`.
 *
 * Index 0 = oldest day in window, `windowDays - 1` = today.
 * Returns -1 for invalid timestamps or dates outside the window.
 */
export function dayIndex(iso: string, windowDays: number, now: Date = new Date()): number {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return -1;
  const todayMs = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const dayMs = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  const diff = Math.round((todayMs - dayMs) / 86400000);
  if (diff < 0 || diff >= windowDays) return -1;
  return windowDays - 1 - diff;
}
